import { render } from "./brandProductEdit.vue?vue&type=template&id=0a9a652f&scoped=true"
import script from "./brandProductEdit.vue?vue&type=script&lang=js"
export * from "./brandProductEdit.vue?vue&type=script&lang=js"

import "./brandProductEdit.vue?vue&type=style&index=0&id=0a9a652f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9a652f"],['__file',"src/views/brandProduct/brandProductEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a9a652f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a9a652f', __exports__)) {
    console.log('reload')
    api.reload('0a9a652f', __exports__)
  }
  
  module.hot.accept("./brandProductEdit.vue?vue&type=template&id=0a9a652f&scoped=true", () => {
    console.log('re-render')
    api.rerender('0a9a652f', render)
  })

}


export default __exports__